import { FunctionComponent, memo } from "react";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { IProps } from "./create-tag-group-button.types";
import { Button } from "@edgetier/components";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import CreateTagGroup from "../create-tag-group/create-tag-group";
import "./create-tag-group-button.scss";

/**
 * A button that, when clicked, will open a modal with a form to create a tag group.
 */
const CreateTagGroupButton: FunctionComponent<IProps> = () => {
    const { modalProps, openModal } = useModal();
    return (
        <div className="create-tag-group-button">
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>Create Tag Group</h2>
                </ModalHeader>
                <ModalContent>
                    <CreateTagGroup />
                </ModalContent>
            </Modal>
            <Button onClick={openModal} icon={faPlus} styleName="positive">
                Create Tag Group
            </Button>
        </div>
    );
};

export default memo(CreateTagGroupButton);
